import { Component, OnInit } from '@angular/core';
import { StorageService } from '../Services/storage.service';

@Component({
  selector: 'app-congres-welcome',
  templateUrl: './congres-welcome.component.html',
  styleUrls: ['./congres-welcome.component.scss']
})
export class CongresWelcomeComponent implements OnInit {

  showProgramme = false;

  constructor(private storageservice:StorageService) { }

  ngOnInit() {
  }

  preventAction($event){
    $event.preventDefault();
  }

  showProgrammePopup(){
    this.showProgramme = true;
  }

  closeProgrammePopup(){
    this.showProgramme = false;
  }

}
